// @flow

import type { Merchant } from '@tectonics/prs/merchant/types';

export function getThemeId(merchant: Merchant): string {
  return merchant.theme;
}
